module.exports = __webpack_public_path__ + "img/staple-food.ffcda29a.svg";